var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"in-out"}},[(_vm.showCanvas)?_c('canvas',{staticClass:"zoom",attrs:{"id":"zoom"},on:{"touchstart":_vm.delCanvas,"mouseup":_vm.delCanvas}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }